import PropTypes from "prop-types";

// Renders nothing until the contact loads, so callers can pass it straight through
// without checking for null themselves.
const TechSupportQuestions = ({ contact, children }) => {
  if (!contact) return null;

  return (
    <p>
      {children}
      {children ? " " : ""}
      Questions? {contact.phone && `Call ${contact.phone} or `}
      {contact.text && `Text support at ${contact.text} or `}
      email {contact.email}.
    </p>
  );
};

TechSupportQuestions.propTypes = {
  contact: PropTypes.shape({
    phone: PropTypes.string,
    text: PropTypes.string,
    email: PropTypes.string,
  }),
  children: PropTypes.node,
};

export default TechSupportQuestions;
